export default {
    templateDataBegin(state) {
        state.loadingTemplate = true;
        state.errorTemplate = false;
    },
    templateDataSuccess(state, data) {
        state.template = data;
        state.loadingTemplate = false;
    },
    templateDataErr(state, err) {
        state.loadingTemplate = false;
        state.errorTemplate = err;
    },
    templatesDataBegin(state, query) {
        if (query) state.listQuery = query;
        state.loadingTemplates = true;
    },
    templatesDataSuccess(state, data) {
        state.pageSize = Number((data.meta || data).per_page) || state.pageSize;
        state.templates = data.data;
        state.count = data.meta.total;
        state.currentPage = data.meta.current_page;
        state.loadingTemplates = false;
    },
    templatesDataErr(state, err) {
        state.loadingTemplates = false;
        state.errorTemplates = err;
    },
    templateDataCreateBegin(state) {
        state.loadingCreateTemplate = true;
    },
    templateDataCreateSuccess(state) {
        state.loadingCreateTemplate = false;
    },
    templateDataCreateErr(state, err) {
        state.loadingCreateTemplate = false;
        state.errorCreateTemplate = err;
    },
    templateDataPatchBegin(state) {
        state.loadingPatchTemplate = true;
    },
    templateDataPatchSuccess(state) {
        state.loadingPatchTemplate = false;
    },
    templateDataPatchErr(state, err) {
        state.loadingPatchTemplate = false;
        state.errorPatchTemplate = err;
    },
    templateDataDeleteBegin(state) {
        state.loadingDeleteTemplate = true;
    },
    templateDataDeleteSuccess(state) {
        state.loadingDeleteTemplate = false;
    },
    templateDataDeleteErr(state, err) {
        state.loadingDeleteTemplate = false;
        state.errorDeleteTemplate = err;
    },
    templatePreviewBegin(state) {
        state.loadingPreview = true;
    },
    templatePreviewSuccess(state, data) {
        state.previewData = data;
        state.loadingPreview = false;
    },
    templatePreviewErr(state, err) {
        state.loadingPreview = false;
        state.errorPreview = err;
    },
    templateValidateBegin(state) {
        state.loadingValidate = true;
    },
    templateValidateSuccess(state, data) {
        state.validationData = data;
        state.loadingValidate = false;
    },
    templateValidateErr(state, err) {
        state.loadingValidate = false;
        state.errorValidate = err;
    },
    templateVariablesBegin(state) {
        state.loadingVariables = true;
    },
    templateVariablesSuccess(state, data) {
        state.variables = data;
        state.loadingVariables = false;
    },
    templateVariablesErr(state, err) {
        state.loadingVariables = false;
        state.errorVariables = err;
    },
    setCurrentPageTemplates(state, page) {
        state.currentPage = page;
    },
};

